import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles, {
  ContainerPrincipal,
  TitleTable,
} from './RendimentoMensalNegociadoresStyles';
import { GroupDefinitions } from '../../../components/NavBar/Dialog/DialogAlterarSenhaStyles';
import RadioField from '../../../components/UI/Field/Radio/RadioField';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import { ButtonUI, SelectorField } from '../../../components';
import SelectorModel from '../../../models/SelectorModel';
import {
  findRendimentoMensalNegociador, findUsuariosNegociadores, imprimirRendimentoMensalNegociadorExcel, imprimirRendimentoMensalNegociadorPdf,
} from '../../../services/core/analiseGerencial/analiseGerencial.service';
import DateField from '../../../components/UI/Field/Date/DateField';
import {
  downloadFileSispag, openPageFileBase64, toBrazilianDate,
} from '../../../helpers';
import CheckboxField from '../../../components/UI/Field/Checkbox/CheckboxField';
import Dica from '../../../components/UI/Dica/Dica';
import SearchButtonWithLabel from '../../../components/UI/Button/Search/Label/SearchButtonWithLabel';
import { ClearButton } from '../../../components/AtualizarMuralDashboard/atualizarMuralDashboard.styles';
import TabelaRendimentoMensalNegociador from './TabelaRendimentoMensalNegociador';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';

function RendimentoMensalNegociadorComponent() {
  const styles = useStyles();

  const [tipoConsultaDefinition, setTipoConsultaDefinition] = useState('T');
  const [negociadorEspecifico, setNegociadorEspecifico] = useState(false);
  const [idUsuarioNegociador, setIdUsuarioNegociador] = useState('');
  const [usuariosNegociadores, setUsuariosNegociadores] = useState([]);
  const [dataReferencia, setDataReferencia] = useState(toBrazilianDate(new Date()));
  const [dataReferenciaNova, setDataReferenciaNova] = useState(toBrazilianDate(new Date()));
  const [selecionarDosDoisSistemas, setSelecionarDosDoisSistemas] = useState(true);
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeTipoConsultaHandler = useCallback((event) => {
    const { value } = event.target;
    setTipoConsultaDefinition(value);
    setNegociadorEspecifico(value === 'N');
    if (value !== 'N') {
      setIdUsuarioNegociador('');
    }
  }, [setNegociadorEspecifico, setTipoConsultaDefinition]);

  const onSubmitHandler = useCallback(() => {
    setLoading(true);
    setContent([]);
    setDataReferenciaNova(dataReferencia);

    findRendimentoMensalNegociador(dataReferencia, idUsuarioNegociador, tipoConsultaDefinition, selecionarDosDoisSistemas)
      .then((response) => {
        setContent(response.data);
        if (response.data.length === 0) {
          toast.error('Nenhum resultado foi encontrado relacionado à sua pesquisa');
        } else {
          toast.success('Pesquisa realizada com sucesso!');
        }
      }).finally(() => {
        setLoading(false);
      });
  }, [dataReferencia, idUsuarioNegociador, tipoConsultaDefinition, selecionarDosDoisSistemas]);

  const onLimparHandler = useCallback(() => {
    setTipoConsultaDefinition('T');
    setNegociadorEspecifico(false);
    setIdUsuarioNegociador('');
    setDataReferencia(toBrazilianDate(new Date()));
    setDataReferenciaNova(toBrazilianDate(new Date()));
    setSelecionarDosDoisSistemas(true);
    setContent([]);
  }, []);

  const onClickExportarExcel = useCallback(() => {
    setLoading(true);
    imprimirRendimentoMensalNegociadorExcel(dataReferencia, idUsuarioNegociador, tipoConsultaDefinition, selecionarDosDoisSistemas).then((response) => {
      if (response.data.length > 0) {
        downloadFileSispag(response.headers.filename, response.data);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [tipoConsultaDefinition, dataReferencia, idUsuarioNegociador, selecionarDosDoisSistemas]);

  const onClickExportarPDF = useCallback(() => {
    setLoading(true);
    imprimirRendimentoMensalNegociadorPdf(dataReferencia, idUsuarioNegociador, tipoConsultaDefinition, selecionarDosDoisSistemas).then((response) => {
      if (response.data.length > 0) {
        openPageFileBase64(response.data, response.headers['content-type']);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o PDF. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [tipoConsultaDefinition, dataReferencia, idUsuarioNegociador, selecionarDosDoisSistemas]);

  useEffect(() => {
    if (usuariosNegociadores.length === 0) {
      findUsuariosNegociadores().then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuariosNegociadores(resposta);
      });
    }
  }, [usuariosNegociadores.length]);

  return (
    <ContainerPrincipal>
      <LoadingUI show={loading} />

      <div style={{ border: '1px solid', padding: '10px', width: '60%' }}>
        <WrapperSubTitleForm title="Opções de consulta">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ border: '1px solid', padding: '10px', width: '70%' }}>
              <GroupDefinitions
                aria-label="tipoConsulta"
                value={tipoConsultaDefinition}
                onChange={onChangeTipoConsultaHandler}
              >
                <div style={{ width: '100%' }}>
                  <RadioField
                    label="Todos os Negociadores"
                    value="T"
                    style={{ marginTop: '0px' }}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex' }}>
                  <RadioField label="Negociador:" value="N" style={{ marginTop: '0px' }} />
                  <SelectorField
                    style={{ width: '300px' }}
                    isForm
                    hasEmptyLabel
                    disabled={negociadorEspecifico !== true}
                    items={usuariosNegociadores}
                    name="idUsuarioNegociador"
                    value={idUsuarioNegociador}
                    onChange={(e) => {
                      setIdUsuarioNegociador(e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: '100%' }}>
                  <RadioField label="Apenas Negociadores Internos" value="I" style={{ marginTop: '0px' }} />
                </div>
                <div style={{ width: '100%' }}>
                  <RadioField label="Apenas Negociadores Externos" value="E" style={{ marginTop: '0px' }} />
                </div>
              </GroupDefinitions>
            </div>

            <div style={{
              border: '1px solid', padding: '10px', width: '28%', alignContent: 'center',
            }}
            >
              <div style={{ margin: '5px' }}>
                <DateField
                  isForm
                  label="Data de Referência"
                  name="Data de Referência"
                  value={dataReferencia}
                  onChange={e => setDataReferencia(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <div>
                <CheckboxField
                  label="Selecionar dados dos dois sistemas"
                  name="selecionarDosDoisSistemas"
                  checked={selecionarDosDoisSistemas}
                  onChange={e => setSelecionarDosDoisSistemas(e.target.checked)}
                />
              </div>
              <div>
                <Dica mensagemDica="Utilizar dados do sistema ABE e do sistema ABE Web para geração do relatório." />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <div>
              <ClearButton
                style={{ width: '150px' }}
                onClick={() => { onLimparHandler(); }}
                iconFontAwesome="fas fa-eraser"
                label="Limpar"
              />
              <SearchButtonWithLabel
                style={{ width: '150px', marginLeft: '10px' }}
                label="Pesquisar"
                type="button"
                onClick={() => { onSubmitHandler(); }}
              />
            </div>
          </div>
        </WrapperSubTitleForm>
      </div>
      <div style={{
        border: '1px solid', padding: '10px', width: '100%', marginTop: '10px',
      }}
      >
        <WrapperSubTitleForm title="Exportar">
          <div style={{ marginTop: '10px' }}>
            <ButtonUI
              style={{ width: '100px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarExcel(); }}
            >
              Excel
            </ButtonUI>
            <ButtonUI
              style={{ width: '100px', marginLeft: '10px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarPDF(); }}
            >
              PDF
            </ButtonUI>
          </div>
          <TitleTable>
            Rendimento Mensal dos Negociadores
          </TitleTable>
          <TabelaRendimentoMensalNegociador
            content={content}
            dataBase={dataReferenciaNova}
          />
        </WrapperSubTitleForm>
      </div>
    </ContainerPrincipal>
  );
}

export const RendimentoMensalNegociadores = withRouter(RendimentoMensalNegociadorComponent);
